import * as React from 'react'
import { Link } from 'gatsby'
import { Container } from 'react-bootstrap'
import SiteLogo from '../SiteLogo/SiteLogo'
import GlobalHeaderLoginFormClient from '@components/_Global/GlobalHeader/parts/GlobalHeaderLoginFormClient'
import GlobalHeaderLoginFormPartner from '@components/_Global/GlobalHeader/parts/GlobalHeaderLoginFormPartner'
import { UserType, PageType } from '@type/component-data-types.d'

const GlobalHeaderMobileNavigation = React.lazy(
  () =>
    import('@components/_Global/GlobalMobileNavigation/GlobalMobileNavigation'),
)

type Props = {
  pageType?: PageType
  userType: UserType
  children?: React.ReactNode
}

const GlobalHeader = (props: Props): React.JSX.Element => {
  // ログインフォームはページによって表示するものが異なるため、ユーザータイプとページタイプから表示するフォームを判定する
  const usePartnerForm =
    props.userType === 'partner' || props.userType === 'both'
  const useClientForm = props.userType === 'client' || props.userType === 'both'
  // client-no-form: クライアント向けレイアウトだがログインフォームを表示しない

  const pageType = props.pageType === 'index'

  return (
    <>
      <div className="globalHeader">
        <Container fluid="lg" className="globalHeader__container">
          <div className="globalHeader__body">
            <header className="globalHeader__logo mx-auto">
              {pageType ? (
                <SiteLogo pageType={props.pageType} />
              ) : (
                <Link to="/">
                  <SiteLogo pageType={props.pageType} />
                </Link>
              )}
            </header>

            <div className="globalHeader__partnerForm">
              {usePartnerForm === true && <GlobalHeaderLoginFormPartner />}
            </div>

            <div className="globalHeader__clientForm">
              {useClientForm === true && <GlobalHeaderLoginFormClient />}
            </div>

            <div className="globalHeader__menuToggle">
              <React.Suspense fallback="">
                <GlobalHeaderMobileNavigation isUserType={props.userType} />
              </React.Suspense>
            </div>
          </div>
        </Container>
      </div>

      {props.children}
    </>
  )
}

export default GlobalHeader
